import { useId, useState } from "react";
import type { Update } from "@shared/contracts";
import { formatDateTime } from "../../platform/time/format-date";
import { GlowPanel } from "../../platform/ui/GlowPanel";
import { ModalDialog } from "../../platform/ui/ModalDialog";
import { useOverflows } from "../../platform/ui/useOverflows";

/**
 * One thing Orla has been up to, on a plate like the one her email form sits on. The plate
 * is the size its place on the board gives it, so a long note is cut short with a way to
 * read all of it, never a scroll.
 */
export function UpdateItem({ update }: { update: Update }) {
  const [body, cutShort] = useOverflows<HTMLParagraphElement>();
  const [reading, setReading] = useState(false);
  const titleId = useId();
  const when = formatDateTime(update.createdAt);

  return (
    <GlowPanel variant="feature" className="update-item">
      <article className="update-item__plate">
        <time className="update-item__time" dateTime={update.createdAt}>
          {when}
        </time>
        <p className="update-item__body" ref={body} data-cut-short={cutShort}>
          {update.body}
        </p>
        <div className="update-item__foot">
          {cutShort ? (
            <button
              type="button"
              className="update-item__more"
              onClick={() => {
                setReading(true);
              }}
            >
              Read it all
            </button>
          ) : null}
          {update.link ? (
            <a className="update-item__link" href={update.link.url} rel="noopener noreferrer">
              {update.link.label}
              <span aria-hidden="true">&nbsp;&rarr;</span>
            </a>
          ) : null}
        </div>
      </article>
      <ModalDialog
        open={reading}
        onClose={() => {
          setReading(false);
        }}
        labelledBy={titleId}
        placement="centre"
        width={34}
      >
        <GlowPanel variant="feature">
          <div className="update-reader">
            <h2 className="update-item__time" id={titleId}>
              {when}
            </h2>
            <p className="update-reader__body">{update.body}</p>
            <button
              type="button"
              className="update-item__more"
              onClick={() => {
                setReading(false);
              }}
            >
              Close
            </button>
          </div>
        </GlowPanel>
      </ModalDialog>
    </GlowPanel>
  );
}
